import { render, staticRenderFns } from "./MailFail.vue?vue&type=template&id=dfbc3eac&scoped=true"
import script from "./MailFail.vue?vue&type=script&lang=js"
export * from "./MailFail.vue?vue&type=script&lang=js"
import style0 from "./MailFail.vue?vue&type=style&index=0&id=dfbc3eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbc3eac",
  null
  
)

export default component.exports